import { h, Fragment } from "preact";

export default function ProductSwatch({
  product,
  active,
  showLabel,
  onlyActive,
}) {
  const image =
    product.swatchImage?.reference?.image?.url ||
    product.media[0]?.previewImage?.url;

  const content = () => (
    <>
      {showLabel && (
        <div className="product-form__swatch-label">
          {product.helpers.color}
        </div>
      )}
      <div className="product-form__swatch-wrapper">
        <div className="product-form__swatch">
          <pdp-variant-button product-url={product.helpers.url} />
          <img
            className={`product-form__swatch-image
            ${active ? "product-form__swatch-image--active" : ""}
            ${
              product.helpers.isLightColor
                ? "product-form__swatch-image--light"
                : ""
            }
            `}
            src={getSizedImageUrl(image, "x100")}
            alt={`${product.title} in ${product.helpers.color}`}
          />
        </div>
      </div>
    </>
  );

  return active ? (
    <span className="product-form__swatch-item">{content()}</span>
  ) : (
    <a
      className="product-form__swatch-item"
      href={product.helpers.url}
      data-variant-link
    >
      {content()}
    </a>
  );
}
